import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { CarePlan } from './CarePlan';
import { ChatInterface } from './ChatInterface';
import { ConciergeHandoff } from './ConciergeHandoff';
import Dashboard from './Dashboard';
import { ProviderMatching } from './ProviderMatching';
import { ProviderOverview } from './ProviderOverview';
import { SituationSummary } from './SituationSummary';
import { TransitionMessage } from './TransitionMessage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export const LatestDesignChatbotPage = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route index element={<ChatInterface />} />
        <Route path="situation-summary" element={<SituationSummary />} />
        <Route path="provider-overview" element={<ProviderOverview />} />
        <Route path="matching/:categoryIndex" element={<ProviderMatching />} />
        <Route path="transition" element={<TransitionMessage />} />
        <Route path="plan" element={<CarePlan />} />
        <Route path="concierge" element={<ConciergeHandoff />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
};
